define('view/disclosure/disclosure.modals',['require','exports','module','view/disclosure/modals/disclosure.type.modal'],function(require, exports, module) {
  //prettier-ignore
  var DisclosureTypeModal    = require('view/disclosure/modals/disclosure.type.modal');

  var DisclosureModals = {
    //Modals
    disclosureTypeModal: {
      type: DisclosureTypeModal,
    },
  };

  module.exports = DisclosureModals;
});

